import { render } from "./activityScale.vue?vue&type=template&id=3bbc2e7c&scoped=true"
import script from "./activityScale.vue?vue&type=script&lang=js"
export * from "./activityScale.vue?vue&type=script&lang=js"

import "./activityScale.vue?vue&type=style&index=0&id=3bbc2e7c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbc2e7c"]])

export default __exports__